import { action, computed, observable } from 'mobx'
import { JtechStore } from 'src/plugins/mobx'
import actions from '../constants/billingOrderButtonsAction.js'

export default class BillingOrderActionButtonsState {
    @observable action = actions.SEND_MEASUREAMENT;

    static getInstance () {
      return JtechStore.getSingleton('billingOrderActionButtonsState', new BillingOrderActionButtonsState())
    }

    @action.bound setAction (action) {
      this.action = action
    }
}
